import { createSlice } from '@reduxjs/toolkit';

export const latLng = createSlice({
  name: 'latLng',
  initialState: {
    data: {},
  },

  reducers: {
    setLatLng: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setLatLng } = latLng.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getLatLng = (state) => state.latLng.data;

export default latLng.reducer;
